import React, { useEffect, useRef } from "react"

export function CursorRenderer({ config }) {
  const dotRef = useRef(null)
  const textRef = useRef(null)
  const raf = useRef(null)
  const mouse = useRef({ x: 0, y: 0 })
  const pos = useRef({ x: 0, y: 0 })
  const lerpRef = useRef(config.lerp ?? 0.18)
  lerpRef.current = config.lerp ?? 0.18 // update w/o restarting loop

  // mount once: mousemove + rAF loop, lives for app lifetime
  useEffect(() => {
    const isCoarse = window.matchMedia("(pointer: coarse)").matches
    if (isCoarse) return // no custom cursor on touch

    const onMove = (e) => {
      mouse.current.x = e.clientX
      mouse.current.y = e.clientY
    }
    window.addEventListener("mousemove", onMove, { passive: true })

    const loop = () => {
      const l = lerpRef.current
      pos.current.x += (mouse.current.x - pos.current.x) * l
      pos.current.y += (mouse.current.y - pos.current.y) * l
      const el = dotRef.current
      if (el) {
        el.style.transform =
          `translate3d(${pos.current.x}px, ${pos.current.y}px, 0) translate(-50%, -50%)`
      }
      raf.current = requestAnimationFrame(loop)
    }
    raf.current = requestAnimationFrame(loop)

    return () => {
      cancelAnimationFrame(raf.current)
      window.removeEventListener("mousemove", onMove)
    }
  }, [])

  if (window.matchMedia("(pointer: coarse)").matches) return null

  return (
    <div
      ref={dotRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        pointerEvents: "none",
        width: config.size,
        height: config.size,
        background: config.background,
        color: config.color,
        borderRadius: config.borderRadius,
        border: config.border || "none",
        mixBlendMode: config.blendMode || "normal",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 1,
        transition: "width .3s cubic-bezier(.16,1,.3,1), height .3s cubic-bezier(.16,1,.3,1), background .3s, border-radius .3s, color .3s",
        willChange: "transform",
      }}
    >
      {config.isIcon && config.iconPath && (
        <div className="flex flex-col items-center">
        <img
          src={config.iconPath}
          alt=""
          draggable="false"
          style={{
            width: "70%",
            height: "70%",
            objectFit: "contain",
            pointerEvents: "none",
          }}
          />
          <span
          className="font-pixeloperator text-xs"
          ref={textRef}
        >
          {config.text}
        </span>
          </div>
      )}

      {config.text && !config.isIcon && (
        <span
          className="font-pixeloperator text-lg"
          ref={textRef}
        >
          {config.text}
        </span>
      )}
    </div>
  )
}